module.exports = __webpack_public_path__ + "img/img_ranking3_L.176bff05.png";